<template>
  <ClientOnly>
    <UButton
      :class="['themeMode', customClass || 'ml-3']"
      :color="variant === 'nav-item' ? undefined : 'gray'"
      :variant="variant === 'nav-item' ? undefined : 'ghost'"
      :aria-label="isDark ? 'Включить светлую тему' : 'Включить тёмную тему'"
      @click="toggleTheme"
    >
      <template #trailing>
        <div class="flex items-center gap-4">
          <!--
            Иконка показывает ТЕКУЩУЮ тему, подпись — что будет по нажатию.

            `:key` обязателен: без него Vue переиспользует узел, а анимация
            line-md проигрывается один раз при монтировании — переход
            «солнце → луна» просто не запускался бы.

            `mode="svg"` тоже обязателен: по умолчанию @nuxt/icon рисует иконку
            CSS-маской, а SVG внутри background/mask браузер держит в «статичном»
            режиме — объявленные в нём анимации не идут вовсе.
          -->
          <Icon
            :key="isDark ? 'moon' : 'sun'"
            mode="svg"
            :name="isDark ? 'line-md:sunny-outline-to-moon-transition' : 'line-md:moon-to-sunny-outline-transition'"
            class="themeMode__icon"
          />
          <span v-if="!hideLabel" :class="variant === 'nav-item' ? '' : 'lg:hidden'" class="text-base">
            {{ isDark ? 'Включить светлую тему' : 'Включить темную тему' }}
          </span>
        </div>
      </template>
    </UButton>
    <template #fallback>
      <div class="w-8 h-8"></div>
    </template>
  </ClientOnly>
</template>

<script setup>
import { useDarkMode } from '@shared/lib';

defineProps({
  variant: {
    type: String,
    default: 'default',
  },
  customClass: {
    type: String,
    default: '',
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
});

const { isDark, toggleTheme } = useDarkMode();
</script>

<style scoped lang="scss">
.themeMode {
  @apply relative z-30;

  span{
    @apply lg:hidden;
  }

  &__icon {
    @apply w-5 h-5;
    // Собственного view-transition-name у иконки намеренно НЕТ: кнопка живёт
    // сразу в нескольких местах (шапка, бургер-меню, админка — там их две
    // на странице), а повторяющееся имя отменяет весь переход целиком.
  }
}
</style>
